const BASE = process.env.REACT_APP_API_URL || '';

let token = localStorage.getItem('cs_token') || '';

export function setToken(t) { token = t; localStorage.setItem('cs_token', t); }
export function getToken() { return token; }
export function isAuthed() { return !!token; }
export function logout() { token = ''; localStorage.removeItem('cs_token'); }

async function req(method, path, body) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  if (res.status === 401) { logout(); window.location.reload(); throw new Error('Unauthorized'); }
  if (!res.ok) { const err = await res.json().catch(() => ({ error: res.statusText })); throw new Error(err.error || res.statusText); }
  return res.json();
}

export const api = {
  login: (password, username) => username ? req('POST', '/api/auth', { username, password }) : req('POST', '/api/auth', { password }),
  // Current user
  getMe: () => req('GET', '/api/me'),
  changePassword: (current_password, new_password) => req('PUT', '/api/me/password', { current_password, new_password }),
  // Users (owner only)
  getUsers: () => req('GET', '/api/users'),
  createUser: (data) => req('POST', '/api/users', data),
  updateUser: (id, data) => req('PUT', `/api/users/${id}`, data),
  deleteUser: (id) => req('DELETE', `/api/users/${id}`),
  // Counselors
  getCounselors: () => req('GET', '/api/counselors'),
  createCounselor: (data) => req('POST', '/api/counselors', data),
  updateCounselor: (id, data) => req('PUT', `/api/counselors/${id}`, data),
  deleteCounselor: (id) => req('DELETE', `/api/counselors/${id}`),
  setIntakeCap: (id, week_start, cap) => req('PUT', `/api/counselors/${id}/intake-cap`, { week_start, cap }),
  getHoursOverrides: (id) => req('GET', `/api/counselors/${id}/hours-overrides`),
  addHoursOverride: (id, data) => req('POST', `/api/counselors/${id}/hours-overrides`, data),
  deleteHoursOverride: (id) => req('DELETE', `/api/hours-overrides/${id}`),
  // Clients
  getClients: () => req('GET', '/api/clients'),
  createClient: (data) => req('POST', '/api/clients', data),
  updateClient: (id, data) => req('PUT', `/api/clients/${id}`, data),
  // Appointments
  getAppointments: (params) => { const qs = new URLSearchParams(params).toString(); return req('GET', `/api/appointments?${qs}`); },
  getIntakeSlots: (params) => { const qs = new URLSearchParams(params).toString(); return req('GET', `/api/intake-slots?${qs}`); },
  createAppointment: (data) => req('POST', '/api/appointments', data),
  updateAppointment: (id, data) => req('PUT', `/api/appointments/${id}`, data),
  deleteAppointment: (id, opts) => { const qs = opts ? `?${new URLSearchParams(opts)}` : ''; return req('DELETE', `/api/appointments/${id}${qs}`); },
  // Reminders
  getReminderConfig: () => req('GET', '/api/reminder-config'),
  updateReminderConfig: (program, data) => req('PUT', `/api/reminder-config/${program}`, data),
  // Intake reminder schedule (per-program list)
  getIntakeReminders: () => req('GET', '/api/intake-reminders'),
  addIntakeReminder: (program, data) => req('POST', `/api/intake-reminders/${program}`, data),
  updateIntakeReminder: (id, data) => req('PUT', `/api/intake-reminders/${id}`, data),
  deleteIntakeReminder: (id) => req('DELETE', `/api/intake-reminders/${id}`),
  // Send appointment confirmation (immediate, on-demand)
  sendConfirmation: (apptId) => req('POST', `/api/appointments/${apptId}/send-confirmation`),
  // Reports
  getCaseload: () => req('GET', '/api/reports/caseload'),
  // Group roster
  getPreviousGroupRoster: (counselor_id, group_name, before_date) => req('GET', `/api/appointments/previous-group-roster?counselor_id=${counselor_id}&group_name=${encodeURIComponent(group_name)}&before_date=${before_date}`),
  // Global Topics
  getGlobalTopics: () => req('GET', '/api/global-topics'),
  updateGlobalTopics: (topics) => req('PUT', '/api/global-topics', { topics }),
  // Settings (owner only)
  getSettings: () => req('GET', '/api/settings'),
  saveSettings: (data) => req('PUT', '/api/settings', data),
  testEmail: (to) => req('POST', '/api/settings/test-email', { to }),
  testSMS: (to) => req('POST', '/api/settings/test-sms', { to }),
  triggerReminders: () => req('POST', '/api/settings/trigger-reminders'),
};
